import { render, staticRenderFns } from "./PersonApplyRoom.vue?vue&type=template&id=84a2c55a&scoped=true"
import script from "./PersonApplyRoom.vue?vue&type=script&lang=js"
export * from "./PersonApplyRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a2c55a",
  null
  
)

export default component.exports